export default "__VITE_ASSET__BCM4f8oM__"